import validate from "/builds/common/careers/careers-static/node_modules/nuxt/dist/pages/runtime/validate.js";
import onload_45global from "/builds/common/careers/careers-static/middleware/onload.global.ts";
export const globalMiddleware = [
  validate,
  onload_45global
]
export const namedMiddleware = {}